function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 27,
  r: 27,
  fill: "#FFFBED"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 11)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#AD5E47",
  d: "M20.0546114,8.11881336 C19.0409898,7.10519174 18.8239087,5.68075931 19.5685573,4.93611066 L24.0623952,0.44227282 C24.8070438,-0.302375828 26.2323411,-0.0844298825 27.2450979,0.928326874 L30.9147195,4.5979485 C31.9274763,5.61157012 32.1454222,7.03600255 31.4007735,7.7806512 L26.9069357,12.274489 C26.1622871,13.0191377 24.7369898,12.8011917 23.724233,11.788435 L20.0546114,8.11881336 Z",
  transform: "rotate(-90 25.485 6.358)"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#CD546C",
  points: "11.833 1.382 14.375 1.382 14.375 25.314 11.833 25.314",
  transform: "rotate(-135 13.104 13.348)"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#CD546C",
  points: "12.646 3.824 17.73 3.824 17.73 29.486 12.646 29.486",
  transform: "rotate(-135 15.188 16.655)"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#CD546C",
  points: "17.227 6.774 19.768 6.774 19.768 30.706 17.227 30.706",
  transform: "rotate(-135 18.497 18.74)"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FAAD62",
  points: "10.934 23.405 3.645 20.909 1.248 23.306 3.743 30.595 4.642 29.696 6.764 30.021 6.115 25.777 10.359 26.425 10.035 24.304",
  transform: "rotate(-90 6.09 25.752)"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#231F20",
  points: "0 28.198 1.248 31.843 3.645 29.446",
  transform: "rotate(-90 1.822 30.02)"
})));

function SvgBlogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogs);
export default __webpack_public_path__ + "static/media/blogs.97f007bb.svg";
export { ForwardRef as ReactComponent };